'use client';

import React, { useState, Suspense } from 'react';
import { useSearchParams } from 'next/navigation';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';
import AuthBrandPanel from './AuthBrandPanel';

function AuthPageInner() {
  const searchParams = useSearchParams();
  const defaultTab = searchParams.get('tab') === 'signup' ? 'signup' : 'signin';
  const defaultRole = searchParams.get('role') || '';

  const [activeTab, setActiveTab] = useState<'signin' | 'signup'>(
    defaultTab as 'signin' | 'signup'
  );

  return (
    <div className="min-h-screen flex" style={{ background: 'var(--background)' }}>
      {/* Left brand panel */}
      <AuthBrandPanel />

      {/* Right form panel */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12 lg:px-12 xl:px-20 relative overflow-hidden">
        {/* Subtle background */}
        <div className="blob-primary absolute top-0 right-0 w-80 h-80 opacity-30 pointer-events-none" />
        <div className="blob-mint absolute bottom-0 left-0 w-64 h-64 opacity-20 pointer-events-none" />

        <div className="w-full max-w-md relative z-10">
          {/* Mobile logo — official AVEN mark */}
          <div className="flex items-center gap-3 mb-8 lg:hidden">
            <img
              src="/assets/images/file_00000000049881f4ba7bdc2dc261021b-1786785034842.png"
              alt="AVEN Logo"
              width={36}
              height={36}
              className="flex-shrink-0 object-contain w-9 h-9"
            />
            <span className="font-black text-xl tracking-tight text-foreground">AVEN</span>
          </div>

          {/* Tab switcher */}
          <div className="flex p-1 rounded-xl mb-8" style={{ background: 'var(--muted)' }}>
            <button
              onClick={() => setActiveTab('signin')}
              className={`flex-1 py-2.5 text-sm font-semibold rounded-lg transition-all duration-200 ${
                activeTab === 'signin'
                  ? 'bg-card text-foreground shadow-sm'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              Sign In
            </button>
            <button
              onClick={() => setActiveTab('signup')}
              className={`flex-1 py-2.5 text-sm font-semibold rounded-lg transition-all duration-200 ${
                activeTab === 'signup'
                  ? 'bg-card text-foreground shadow-sm'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              Create Account
            </button>
          </div>

          {/* Forms */}
          {activeTab === 'signin' ? (
            <LoginForm onSwitchToSignUp={() => setActiveTab('signup')} />
          ) : (
            <SignUpForm onSwitchToSignIn={() => setActiveTab('signin')} defaultRole={defaultRole} />
          )}
        </div>
      </div>
    </div>
  );
}

export default function AuthPage() {
  return (
    <Suspense
      fallback={
        <div
          className="min-h-screen flex items-center justify-center"
          style={{ background: 'var(--background)' }}
        >
          <div className="w-8 h-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
        </div>
      }
    >
      <AuthPageInner />
    </Suspense>
  );
}
